import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default function () {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const svgContainer = document.querySelector('#container-connecter');

  if (!svgContainer) {
    return;
  }

  const cloud = document.querySelector('#cloud');
  const web = document.querySelector('#web');
  const erp = document.querySelector('#erp');
  const crm = document.querySelector('#crm');

  if (prefersReducedMotion) {
    gsap.set([web, erp, crm, cloud], {
      autoAlpha: 1,
      yPercent: 0
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  const tl = gsap.timeline({
    paused: true
  });

  tl
  .fromTo(web, { autoAlpha: 0, yPercent: -45 }, { autoAlpha: 1, yPercent: 0 })
  .fromTo(erp, { autoAlpha: 0, yPercent: -20 }, { autoAlpha: 1, yPercent: 0 })
  .fromTo(crm, { autoAlpha: 0, yPercent: -20 }, { autoAlpha: 1, yPercent: 0 })
  .fromTo(cloud, { autoAlpha: 0, yPercent: 20 }, { autoAlpha: 1, yPercent: 0 });

  ScrollTrigger.create({
    animation: tl,
    trigger: '#container-connecter',
    start: '0% 35%',
    end: 'bottom bottom',
    scrub: 1,
    markers: false
  });
}
